// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, socialLoginClient } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitSocialLoginClientApi = createAsyncThunk(
  "hitSocialLoginClientApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      };
      const url = ApiBaseUrl + socialLoginClient;
      const response = await axios.post(url, payload, config);
      return response.data;
    } catch (error) {
      showToast(error.response.data.message, "error");
      throw error.response.data;
    }
  }
);

const SocialLoginClientSlice = createSlice({
  name: "socialLoginClientReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearHitSocialLoginClientApi: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitSocialLoginClientApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitSocialLoginClientApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        if (
          action.payload?.status == true &&
          action.payload?.data?.accessToken
        ) {
          localStorage.setItem("clientToken", action.payload.data.accessToken);
          localStorage.setItem("clientId", action.payload.data._id);
        }
      })
      .addCase(hitSocialLoginClientApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearHitSocialLoginClientApi } = SocialLoginClientSlice.actions;
export default SocialLoginClientSlice.reducer;
